import React from 'react';
import styled from 'styled-components/macro';
import { CheckMarkIcon, ClockIcon, DraftIcon, XCloseIcon } from '../../assets';
import { EventFormState } from '../../types/events';
import { themeColors } from '../../theme/theme';
import { NoticeFormState } from '../../types/notices';
import { DeviceSize } from '../../components/basic/DeviceSize';
import { useMessageGetter } from 'react-message-context';
import { FormState } from '../../types/forms';
import { ExpenseReportFormState } from '../../types/expense-reports';

const StateContainer = styled.div<{ $color: string }>`
  display: inline-flex;
  gap: 8px;
  background-color: ${(props) => props.$color};
  color: ${themeColors.m2Black};
  border-radius: 16px;
  padding: 6px 16px;
  font-size: 14px;

  svg {
    width: 12px;
    height: 12px;
  }

  @media ${DeviceSize.desktopS} {
    font-size: 12px;
    svg {
      padding-top: 2px;
    }
  }
`;

const getStateStyle = (state: FormState) => {
  switch (state) {
    case NoticeFormState.Rejected:
    case EventFormState.Rejected:
    case ExpenseReportFormState.Rejected:
      return { color: themeColors.strawberry, icon: <XCloseIcon /> };
    case NoticeFormState.Draft:
    case EventFormState.Draft:
    case ExpenseReportFormState.Draft:
      return { color: themeColors.darkSnow, icon: <DraftIcon /> };
    case NoticeFormState.Published:
    case EventFormState.Published:
    case ExpenseReportFormState.Approved:
      return { color: themeColors.apila, icon: <CheckMarkIcon /> };
    case NoticeFormState.AwaitingApproval:
    case EventFormState.AwaitingApproval:
    case ExpenseReportFormState.AwaitingApproval:
      return { color: themeColors.lemon, icon: <ClockIcon /> };
    default:
      return { color: 'transparent', icon: '' };
  }
};

interface Props {
  state: FormState;
}

const FormStateWithIcon: React.FC<Props> = ({ state }) => {
  const t = useMessageGetter('ownForms.state');
  const { color, icon } = getStateStyle(state);

  return (
    <StateContainer $color={color}>
      <span>{icon}</span>
      <span>{t(`${state}`)}</span>
    </StateContainer>
  );
};

export default FormStateWithIcon;
